import { fitTitle, fitDescription } from "@/lib/seo-text";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { LocationPage } from "@/components/location-page";
import { faqSchema, peninsulaBusinessSchema } from "@/lib/firm";
import { getMoretonBayLocation } from "@/lib/moreton-bay";

export const Route = createFileRoute("/moreton-bay/$suburb")({
  loader: ({ params }) => {
    const content = getMoretonBayLocation(params.suburb);
    // Outlying suburbs were folded into the regional page — keep their URLs alive.
    if (!content) throw redirect({ href: "/moreton-bay", statusCode: 301 });
    return { content };
  },
  head: ({ params, loaderData }) => {
    const content = loaderData?.content;
    if (!content) {
      return { meta: [{ title: fitTitle("Not found") }, { name: "robots", content: "noindex" }] };
    }
    const url = `https://coastsidelaw.com.au/moreton-bay/${params.suburb}`;
    return {
      meta: [
        { title: fitTitle(content.metaTitle) },
        { name: "description", content: fitDescription(content.description) },
        { property: "og:title", content: fitTitle(content.metaTitle) },
        { property: "og:description", content: fitDescription(content.description) },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(faqSchema(content.faqs)) },
        { type: "application/ld+json", children: JSON.stringify(peninsulaBusinessSchema) },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://coastsidelaw.com.au/" },
              { "@type": "ListItem", position: 2, name: "Moreton Bay", item: "https://coastsidelaw.com.au/moreton-bay" },
              { "@type": "ListItem", position: 3, name: content.name, item: url },
            ],
          }),
        },
      ],

    };
  },
  component: MoretonBaySuburb,
});

function MoretonBaySuburb() {
  const { content } = Route.useLoaderData();
  return <LocationPage content={content} />;
}
